import styled from "styled-components";
import { theme } from "../../../theme";

const CardTitleTypo = styled.div`
  ${theme.typo.heading.b18};
  color: ${theme.colors.gray2};
`;

export { CardTitleTypo };
